export default __webpack_public_path__ + "static/media/fv_hr.ff05f43e.svg";